import { Tooltip, TooltipContent, TooltipTrigger } from "components/Tooltip";

/**
 * "↩ Reply" on an email in a thread (never on a text): answer that email.
 * Its people fill the To line, the email is marked as the one being
 * answered and the cursor goes to the reply box. Blue while it is the email
 * being answered.
 */
export default function ReplyLink({
  onClick,
  active = false,
}: {
  onClick: () => void;
  active?: boolean;
}) {
  return (
    <Tooltip>
      <TooltipTrigger>
        <button
          type="button"
          className={`shrink-0 rounded px-1 text-xs font-medium hover:bg-white/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2b77cf] ${
            active ? "text-[#2b77cf]" : "text-gray-500 hover:text-gray-700"
          }`}
          aria-label="Reply to this email"
          aria-pressed={active}
          onClick={onClick}
        >
          ↩ Reply
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <span className="text-xs">Reply to this email</span>
      </TooltipContent>
    </Tooltip>
  );
}
